window.app = window.app || {};
window.app.pageHandler = (function() {

    var inited = false,
        $header,
        $nav,
        wScrollTop = 0,
        wHeight = $(window).height(),
        $w = $(window);

    function init() {
        if (inited) {
            return false;
        }

        $header = $('#header');
        $nav = $('#nav');

        generalEvents();
        scrollHandler();
        $w.on('scroll', function() {
            scrollHandler();
        });

        inited = true;
    }

    function closeMenu() {
        $('#nav-trigger').prop('checked', false);
    }

    function scrollUp() {
        TweenMax.to($('html, body'), 1.3, {
            scrollTop: 0,
            ease: Cubic.easeInOut
        });
    }

    function anchorHandler(url) {
        if (!url || url.indexOf('#') < 0 || url.split('#')[1].length === 0) {
            return false;
        }
        if (url.split('#')[0] != window.location.href.split('#')[0]) {
            return false;
        }

        var hash = '#' + url.split('#')[1],
            $anchor = $(hash + ', [data-anchor="' + hash.slice(1) + '"]');

        var sticky = parseInt($('a[href^="#' + url.split('#')[1] + '"]').attr('data-sticky'));


        if (sticky && window.innerWidth > 1000) {
            window.smoothScrollInstance.disable();
            var calc = sticky * $(window).height();

            TweenMax.to($('html, body'), 1.3, {
                scrollTop: calc,
                ease: Cubic.easeInOut,
                onComplete: function() {
                    window.smoothScrollInstance.enable();
                }
            });
            return true;

        } else {

            if ($anchor.length > 0) {
                TweenMax.to($('html, body'), 1.3, {
                    scrollTop: $anchor.offset().top - 100,
                    ease: Cubic.easeInOut,
                    onComplete: function() {
                        window.smoothScrollInstance.enable();
                    }
                });
                return true;
            } else {
                //TweenMax.to($('html, body'), .5, {scrollTop: 0, ease: Cubic.easeIn});
            }
        }
    }

    function generalEvents() {
        $('body')
            // Scroll To Top
            .on('click', '.scrolltop', scrollUp)
            // Scroll to anchor point
            .on('click', 'a[href^="#"]:not([href="#"])', function(e) {
                var handled = anchorHandler(this.href);
                $('.mobile-nav input').prop('checked', false);
                $('body').removeClass('mobile-open');
                $('.header').removeClass('opened');
                $('.mobile-nav').removeClass('opened');
                if (handled) {
                    e.stopPropagation();
                    e.preventDefault();
                    this.blur();
                    return false;
                }
                return true;
            })
            // close menu by click outside
            .on('click', '#header > .bg', function(e) {
                closeMenu();
            });

        // video
        $(document).on('click', '[data-playvideo]', function() {
            let $this = $('[data-playvideo]');
            let $video = $this.attr('data-playvideo');
            let $player = `<iframe src="https://www.youtube.com/embed/` + $video + `?autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`
            $this.parent().html($player)
        });
    }

    function scrollHandler() {



        // 		function handleScroll() {
        //   const sections = document.querySelectorAll('section.move');
        //   const viewportHeight = window.innerHeight;

        //   sections.forEach(section => {
        //     const rect = section.getBoundingClientRect();
        //     const visibleHeight = Math.max(0, Math.min(viewportHeight, rect.bottom) - Math.max(0, rect.top));

        //     if (visibleHeight >= viewportHeight * 0.7) {
        //       section.style.opacity = 1;
        //     } else if (visibleHeight <= viewportHeight * 0.2) {
        //       section.style.opacity = 0
        //     } else {
        //       const opacity = (visibleHeight / (viewportHeight * 0.5)) * 0.5;
        //       section.style.opacity = opacity;
        //       section.style.marginRight = opacity * 100;
        //     }
        //   });
        // }

        // window.addEventListener('scroll', handleScroll);
        // window.addEventListener('resize', handleScroll); // újraszámítás ablak méretezésekor
        // handleScroll(); // kezdeti ellenőrzés betöltéskor

        // const scrollSpeed = 0.8;
        // let currentScroll = window.scrollY;
        // let targetScroll = window.scrollY;

        // function smoothScroll() {
        //     currentScroll += (targetScroll - currentScroll) * scrollSpeed;
        //     window.scrollTo(0, currentScroll);

        //     if (Math.abs(targetScroll - currentScroll) > 0.5) {
        //         requestAnimationFrame(smoothScroll);
        //     }
        // }

        // window.addEventListener('scroll', () => {
        //     targetScroll = window.scrollY;
        //     if (Math.abs(targetScroll - currentScroll) > 0.5) {
        //         requestAnimationFrame(smoothScroll);
        //     }
        // });

        window.addEventListener('scroll', function() {
            const scrollPosition = window.scrollY;
            const background = document.querySelector('#section-bg');
            const content = document.querySelectorAll('section.move');

            if (scrollPosition > $(window).height() * 0.9) {
                $('.header').addClass('scroll')
            } else {
                $('.header').removeClass('scroll')
            }

            if ($('.video-box iframe').length ) {
                var btn = ` <button data-playvideo="yWkxWc61f2c" style="background: #222;">
                                <span class="txt">
                                   
                                   <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="30" cy="30" r="30" fill="#EC1C24"></circle>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M21.9731 19.8231C22.0103 19.5038 22.12 19.1978 22.2933 18.9293C22.4667 18.6608 22.699 18.4374 22.9718 18.2767C23.2445 18.116 23.5503 18.0224 23.8646 18.0036C24.179 17.9847 24.4934 18.041 24.7827 18.1679C26.2454 18.8064 29.5233 20.3238 33.6826 22.775C37.8433 25.2276 40.7699 27.3695 42.0411 28.3412C43.1264 29.1724 43.1292 30.8206 42.0425 31.6546C40.7837 32.6207 37.8928 34.7344 33.6826 37.218C29.4682 39.7015 26.2289 41.2007 24.78 41.8307C23.5322 42.375 22.1356 41.5495 21.9731 40.1755C21.7831 38.5695 21.4277 34.9229 21.4277 29.9979C21.4277 25.0758 21.7817 21.4306 21.9731 19.8231Z" fill="white"></path>
                                    </svg>


                                </span>
                                <video poster="http://127.0.0.1:8000/img/2025-winter/video/cover-finish.jpg" id="bgvid" playsinline="" autoplay="" muted="" loop="" style="opacity: 0.2">
                                    <!-- <source src="/video/cover-video.webm" type="video/webm"> -->
                                    <source src="/video/cover-video.mp4" type="video/mp4">
                                </video>    
                            </button>`
                var top = $('.video-box iframe').offset().top;
                var src = $('.video-box iframe').attr('src');
                if ( 
                    top < scrollPosition + (window.innerHeight /2)
                    &&
                    top > scrollPosition - (window.innerHeight /2)
                    ) {
                    $('.video-box').html(btn)
                }


            }

            var wW = window.innerWidth;
            var pref = 100;

            if (wW < 1400) pref = 150;
            if (wW < 1200) pref = 120;





        });





        $(document).on("scroll", onScroll);

        function onScroll(event) {
            var scrollPos = $(document).scrollTop();
            // $('header nav a').each(function () {
            // 	var currLink = $(this);
            // 	var refElement = $(currLink.attr("href")).closest('section');
            // 	if (!refElement.length) {
            // 		return
            // 	}

            // 	if (refElement.position().top - window.innerHeight < scrollPos) {
            // 		refElement.addClass('anim-in')
            // 	}
            // 	if (refElement.position().top - 150 <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
            // 		$('header nav a').removeClass("active");
            // 		currLink.addClass("active");
            // 	}
            // 	else{
            // 		currLink.removeClass("active");
            // 	}
            // });
        }

        wScrollTop = $(window).scrollTop();



        if (!SMALLSCREEN) {

            if (wScrollTop > wHeight / 10) {
                $header.addClass('sticky');
                $nav.addClass('sticky');
            } else {
                $header.removeClass('sticky');
                $nav.removeClass('sticky');
            }

        }
    }


    let isBelow = window.innerWidth < 1000;

    window.addEventListener('resize', debounce(() => {
        const nowBelow = window.innerWidth < 1000;

        if (nowBelow !== isBelow) {
            location.reload();
        }

        isBelow = nowBelow;
    }, 200));

    function debounce(fn, delay) {
        let timer;
        return function() {
            clearTimeout(timer);
            timer = setTimeout(fn, delay);
        }
    }

    return {
        init: init,
        closeMenu: closeMenu,
        scrollUp: scrollUp,
    };

})();